import NewPasswordForm from '@/components/PageSpecific/login/NewPasswordForm';

export default function NewPasswordStep({
  formData,
  handleInputChange,
  loading,
  handleNewPasswordSubmit,
}) {
  return (
    <NewPasswordForm
      formData={formData}
      handleInputChange={handleInputChange}
      loading={loading}
      handleNewPasswordSubmit={handleNewPasswordSubmit}
    />
  );
}
